/**
 * authGetter.ts
 *
 * Provides a token getter that bridges Clerk React auth to non-React code
 * (e.g. the Axios request interceptor in apiClient.ts).
 *
 * Usage:
 *  1. Call `registerTokenGetter(fn)` from a React component inside ClerkProvider.
 *  2. Call `getAuthToken()` anywhere (including outside React) to get a JWT.
 */

type TokenGetter = () => Promise<string | null>;

let _tokenGetter: TokenGetter = async () => null;

export function registerTokenGetter(fn: TokenGetter): void {
  _tokenGetter = fn;
}

export function getAuthToken(): Promise<string | null> {
  return _tokenGetter();
}
